module.exports = __webpack_public_path__ + "static/media/three-tokens.0ebc35c3.svg";